module.exports = __webpack_public_path__ + "img/1200 MK3D.60366a59.png";